<template>  
  <VUEModal :Titolo="Titolo" 
            :Programma="''" 
            :Altezza="AltezzaPopup * 0.6" 
            :Larghezza="'400px'" 
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="OnClickChiudiModal"
            @OnClickConfermaModal="OnClickConfermaModal">

    <template v-slot:Body>

    <div class="ZMNuovaRigaScheda" style="display:flex">
      <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 1%; margin-top: 3%;">
        <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('VUEPopupNomeModulo','TKN_INS_NOME',this.LinguaUtente) }}</label>
        <div style="width:20px;float:left">&nbsp;</div> 
        <input :placeholder="this.GetTraduzioneLabel('Generic','TKN_NOME',this.LinguaUtente)" class="form-control" type="text" style="float: left; width: calc(40%)" v-model="NomeModulo">
      </div>
    </div>

    </template>
   
    <template  v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="OnClickChiudiModal" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="CanRecord()" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="OnClickConfermaModal"  data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
 
  </VUEModal>


</template>

<script>  

import VUEModal from '@/utils/VUEModal.vue';            
import { SystemInformation} from '@/SystemInformation'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';

export default 
{
  data()
  {
   return {
            LinguaUtente : SystemInformation.UserInformation.Lingua,
            NomeModulo   : ''
          }
  },

  props : ['AltezzaPopup', 'Titolo'],
  emits : ['OnClickChiudiPopup', 'OnClickConfermaPopup'],
  mixins: [MixInsGestioneTraduzioni],
  components: { 
                VUEModal
              },

  methods :
  {
    OnClickChiudiModal()
    {
      this.$emit('OnClickChiudiPopup')
    },

    OnClickConfermaModal()
    {
      this.$emit('OnClickConfermaPopup', this.NomeModulo)
    },

    CanRecord()
    {
      return this.NomeModulo != ''
    },
  },

  watch:
  {
  },

  beforeMount()
  {
  }
  
}
</script>